import { render, staticRenderFns } from "./searchDls.vue?vue&type=template&id=25a10be9&scoped=true"
import script from "./searchDls.vue?vue&type=script&lang=js"
export * from "./searchDls.vue?vue&type=script&lang=js"
import style0 from "./searchDls.vue?vue&type=style&index=0&id=25a10be9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c18e9a749cc21ff970a79c65ca01237d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a10be9",
  null
  
)

export default component.exports